var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-color-set":""}},[_c('a',{staticClass:"d-block m-0",attrs:{"href":_vm.imageSource,"data-lightbox":""}},[_c('img',{staticClass:"artwork__image",attrs:{"alt":_vm.artworkName,"src":_vm.imageSource,"data-magnify-src":_vm.imageSource}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0da8e98","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/shared/components/artwork_image.vue
// module id = 302
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 15 18 19 26 32 33 40 44 70 83 84 87 88 95 113 117 158 359